import axios from 'axios';

// URL param v=1 is added to make sure cached response is re-fetched. Because of miss configuration
// happened once in nginx server, it caused browser to cache the (failed) response.
const API_URL = '/omaviihde/api?v=1';
const ORDERS_API_URL = '/omaviihde/api/subscriptions,devices,cardlinks';

export function getMainProduct() {
  return dispatch => {
    dispatch({ type: 'OMAVIIHDE_FETCHING' });
    return axios.get(API_URL)
      .then(
        response => {
          if (response.data && response.data.viihdeContract) {
            dispatch({ type: 'OMAVIIHDE_CONTRACT', product: response.data.viihdeContract });
          } else {
            dispatch({ type: 'OMAVIIHDE_NO_CONTRACT' });
          }
        }
      ).catch(() => dispatch({ type: 'OMAVIIHDE_NO_CONTRACT' }));
  };
}

export function resetMainProduct() {
  return dispatch => dispatch({ type: 'OMAVIIHDE_RESET' });
}

export function closeContract() {
  return dispatch => {
    return axios.delete(API_URL)
      .then(() => dispatch(getOrders()))
      .catch(() => dispatch(getOrders()));
  };
}

export function getOrders() {
  return dispatch => {
    return axios.get(ORDERS_API_URL)
      .then(
        response => {
          const data = response.data || {};
          dispatch({ type: 'OMAVIIHDE_ORDERS', data });
        }
      ).catch(() => dispatch({ type: 'OMAVIIHDE_ORDERS', data: {} }));
  };
}

export function resetOrders() {
  return dispatch => dispatch({ type: 'OMAVIIHDE_RESET' });
}



// WEBPACK FOOTER //
// ./web/js/stores/actions/omaviihde.js